
import { LatLng } from '@agm/core';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { Container } from 'app/models/container.model';
import { DriverProcess, DriverProcessDetail, DriverProcessDetailEnum } from 'app/models/driverProcess.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { CarService } from 'app/services/car.service';
import { ContainerService } from 'app/services/container.service';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-routing-machine';
import { NgxSpinnerService } from 'ngx-spinner';
import { isNullOrUndefined } from 'util';

//#region Icon

const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [30, 30],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});

const ContainerIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})

const LeafIcon = L.Icon.extend({
    options: {
        iconSize: [40, 40], //30,30
        iconAnchor: [5, 5], //12,41
        popupAnchor: [15, 0],//1,34
        tooltipAnchor: [16, -28],
        shadowAnchor: [4, 62]
    }
});


L.Marker.prototype.options.icon = iconDefault;

//#endregion

@Component({
    selector: 'app-simulation',
    templateUrl: './simulation.component.html',
    styleUrls: ['./simulation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [PoligonService]
})

export class SimulationComponent implements AfterViewInit {

    capitals: string = '/assets/data/usa-capitals.geojson';
    public startRouting = true // true ise gidiş rotalama aktif
    public finishRouting = false; // true ise dönüş rotalama aktif
    public finishEndControl = true; // false ise rotalama bitti
    public cars:Array<Car>
    public selectCar=null;
    public selectCarControl=null;
    public totalDistance:number = 0;
    public totalDuration:number = 0;
    public totalContainer:number = 0;
    public totalEmptyContainer:number = 0;
    public distanceTraveled:number = 0;
    public totalFullContainer:number = 0;
    public simulation = true;
    public driverProcess: DriverProcess = {};
    private map;
    public start: any
    public finish: any
    public polygon:Poligon
    public destinations: any[]
    public myLocation: L.LatLng = L.latLng(0, 0);
    public car: Car
    private _containers: Array<PoligonDetail> = [];
    public map_car_icon = new LeafIcon({ iconUrl: 'assets/img/garbage-truck.png' });
    public car_marker = L.marker([0, 0], { icon: this.map_car_icon });

    public options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 5000
    };
    constructor(
        private _toastService: ToasterService,
        private _simulationService:SimulationService,
        private appConfigService: AppInitializationService,
        private _spinner:NgxSpinnerService,
        private _http: HttpClient,
        private _translateService:TranslateService,
        private router:Router
    ) {
    }

    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }


    private async initMap(): Promise<void> {
        try {
            this.car = await this._simulationService.getByCar(this.selectCar.plate);
            this.polygon = await this._simulationService.getByPoligon(this.car.polygonId);
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing')
        }

        if (isNullOrUndefined(this.car)) {
            this.car = new Car();
            this.car.plate = this._translateService.instant("UNDEFINED_USER");
        }


        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 15
        });

        await this.mySetLocation(this.map);

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map);
    }


    async ngAfterViewInit(): Promise<void> {

        await this.getCars();
        if(this.selectCar!=null){
            this._spinner.show('routing')
            this.selectCarControl=true;
            await this.initMap();
            await this.getLocationList();
            
            setInterval(() => {
                this.getSimulationPosition(this.map);
       }, 10000);
            setTimeout(async() => {
                    this.mySetLocation(this.map)
                    await this.makeCapitalMarkers(this.map);
                    await this.updateRoutingForRoute();
                    this.locationConfigsSet();
                    await this.SetDriverProcess()
                    this._spinner.hide('routing');                      
                }, 2000);
        }
    }

    public async SetDriverProcess() {
        var dp = localStorage.getItem("driverProcess");
        if (dp) {
            try {
                this.driverProcess = await this._simulationService.getDriverProcessControl(dp);
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
        else {
            try {
                this.driverProcess.carId = this.car.id;
                this.driverProcess.sessionLogId = parseInt(localStorage.getItem('SessionLogId'))
                this.driverProcess.polygonId = this.car.poligon.id;
                this.driverProcess.startLat = this.myLocation.lat;
                this.driverProcess.startLng = this.myLocation.lng;
                this.driverProcess.estimatedDistance = this.totalDistance.toString();
                this.driverProcess.estimatedTime = this.totalDuration.toString();
                this.driverProcess.allContainerCount = this.totalContainer;
                this.driverProcess.fullContainerCount = this.totalFullContainer;
                this.driverProcess.emptyContainerCount = this.totalEmptyContainer;
                this.driverProcess.companyId = this.car.companyId;
                this.driverProcess.startDate = (new Date);
                this.driverProcess.simulation = true;
                this.driverProcess.endDate = null;
                this.driverProcess.shiftId = null;
                this.driverProcess.status = true;
                this.driverProcess = await this._simulationService.addDriverProcess(this.driverProcess);
                localStorage.setItem("driverProcess", this.driverProcess.id.toString())
            } catch (error) {
                console.warn(error);
                this._spinner.hide('routing');
            }
        }
    }

    public async getCars(){
        try {
            this.cars = await this._simulationService.getCars(parseInt(localStorage.getItem('CompanyID')))
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing')
        }
    }

    public locationConfigsSet() {

        if (this.finishEndControl) {
            this.updateRoutingForCar();
            this.updateRoutingForRoute();
        }

    }

    getSimulationPosition(map: L.map): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.simulation == true) {
                if (!isNullOrUndefined(this.start.options.plan._waypoints[1].latLng)) {  // gidiş 
                    this.myLocation.lat = this.start.options.plan._waypoints[1].latLng.lat
                    this.myLocation.lng = this.start.options.plan._waypoints[1].latLng.lng
                }
                else if (this.finishRouting && !isNullOrUndefined(this.finish.options.plan._waypoints[1].latLng)) { //  toplama merkezi
                    this.myLocation.lng = this.finish.options.plan._waypoints[1].latLng.lng
                    this.myLocation.lat = this.finish.options.plan._waypoints[1].latLng.lat
                }
                setTimeout(() => { this.locationConfigsSet(); }, 1000)
            }
        });

    }

    async updateRoutingForCar() { // araba her hangi bir konteynere yaklaştığı zaman rota eleniyor
        var startWaypoints = this.start.options.plan._waypoints;
        startWaypoints = startWaypoints.filter(x => x.latLng != undefined); // Rota bitiminde planın 2. değeri undefined

        const waypointslist: L.LatLng[] = [];
        waypointslist.push(new L.LatLng(this.start.options.plan._waypoints[0].latLng.lat, this.start.options.plan._waypoints[0].latLng.lng)) // gidiş rotasının kendi konumu belirle

        var finishWaypoints = this.finish.options.plan._waypoints;
        finishWaypoints = finishWaypoints.filter(x => x.latLng != undefined); // Rota bitiminde planın 2. değeri undefined

        const waypointsFinish: L.LatLng[] = [];
        waypointsFinish.push(new L.LatLng(this.finish.options.plan._waypoints[0].latLng.lat, this.finish.options.plan._waypoints[0].latLng.lng)) // dönüş rotasının kendi konumu belirle

        if (startWaypoints.length > 1) {
            for (let i = 1; i < startWaypoints.length; i++) { // 0 kendi konumu olduğu için hesaplanması istenmemekte

                if (this.myLocation.distanceTo(this.start.options.plan._waypoints[i].latLng) > 10) {
                    waypointslist.push(new L.LatLng(this.start.options.plan._waypoints[i].latLng.lat, this.start.options.plan._waypoints[i].latLng.lng))
                }else{

                    var containerfind = this._containers.find(x =>
                        {
                            var tempLocation = new L.LatLng(x.container.latitude,x.container.longitude);
                            return tempLocation.distanceTo(this.start.options.plan._waypoints[i].latLng) > 10
                        }
                    )

                    var driverProcessDeteail = new DriverProcessDetail();
                    driverProcessDeteail.carLat = this.myLocation.lat.toString()
                    driverProcessDeteail.carLng = this.myLocation.lng.toString()
                    driverProcessDeteail.containerId = containerfind.container.id;
                    driverProcessDeteail.driverProcessId = this.driverProcess.id;
                    driverProcessDeteail.status = DriverProcessDetailEnum.collected;
                    driverProcessDeteail.visitDate = new Date();
                    this._simulationService.addDriverProcessDetail(driverProcessDeteail);
                }
            }
            this.start.setWaypoints(waypointslist);

            return;
        }
        else if (startWaypoints.length <= 1 && !this.finishRouting) {
            this.startRouting = false
            this.finishRouting = true
            return;
        }

        if (this.finishRouting && finishWaypoints.length > 1) {

            for (let j = 1; j < finishWaypoints.length; j++) {// 0 kendi konumu olduğu için hesaplanması istenmemekte

                if (this.myLocation.distanceTo(this.finish.options.plan._waypoints[j].latLng) > 10) {

                    waypointsFinish.push(new L.LatLng(this.finish.options.plan._waypoints[j].latLng.lat, this.finish.options.plan._waypoints[j].latLng.lng))

                }
                else {
                    try {
                        var containerfind = this._containers.find(x =>
                            x.container.latitude == this.start.options.plan._waypoints[j].latLng.lat.toString()
                        )
                         var dpdetail = new DriverProcessDetail;
                         dpdetail.carLat = this.myLocation.lat.toString();
                         dpdetail.carLng = this.myLocation.lng.toString();
                         dpdetail.status = DriverProcessDetailEnum.collected;
                         dpdetail.driverProcessId = this.driverProcess.id;
                         dpdetail.visitDate = new Date();
                         dpdetail.containerId = containerfind.container.id;
                         this._simulationService.addDetail(dpdetail)

                    } catch (error) {
                        console.warn(error);
                        this._spinner.hide('routing');
                    }
                }
            }

            this.finish.setWaypoints(waypointsFinish);
        }
        else if (this.finishRouting && finishWaypoints.length <= 1) {
            this.finishEndControl = false
            this.driverProcess.endDate = new Date();
            this.driverProcess.endLat = this.myLocation.lat.toString();
            this.driverProcess.endLng = this.myLocation.lng.toString();
            this.driverProcess.distanceTraveled = this.distanceTraveled;
            this._simulationService.updateDriverProcess(this.driverProcess);
                
            if(this.router.url=="/apps/simulation"){
                this._toastService.toastSuccess(this._translateService.instant("THE_PROCESS_IS_COMPLETED"))
                window.location.reload();
            }
            
        }

    }

    async updateRoutingForRoute() { // arabanın güncellenene konumuna göre rota güncelleniyor 

        this.map.removeLayer(this.car_marker)
        this.car_marker = L.marker([this.myLocation.lat, this.myLocation.lng], { icon: this.map_car_icon });
        this.car_marker.addTo(this.map);

        var car_marker_location = this.car_marker.getLatLng();

        this.map.panTo(new L.LatLng(car_marker_location.lat, car_marker_location.lng))

        if (this.startRouting && !isNullOrUndefined(this.start.options.plan._waypoints[1].latLng)) {
            const waypointslist: L.LatLng[] = [];
            var LatLngList = this.start.options.plan._waypoints;

            waypointslist.push(new L.LatLng(this.myLocation.lat, this.myLocation.lng))  //waypointlistin 0. elemanı her zaman arabanın konumu 
            for (let x = 1; x < LatLngList.length; x++) {

                waypointslist.push(new L.LatLng(LatLngList[x].latLng.lat, LatLngList[x].latLng.lng))

            }
            this.start.setWaypoints(waypointslist);

        }

        //  gidiş rotalama işlemi bittiktan sonra dönüş rotlama işlemi için
        if (this.finishRouting && this.finishEndControl && !isNullOrUndefined(this.finish.options.plan._waypoints[1].latLng)) {

            const waypointsFinish: L.LatLng[] = [];
            var LatLngList = this.finish.options.plan._waypoints;

            waypointsFinish.push(new L.LatLng(this.myLocation.lat, this.myLocation.lng))

            for (let x = 1; x < LatLngList.length; x++) {

                waypointsFinish.push(new L.LatLng(LatLngList[x].latLng.lat, LatLngList[x].latLng.lng))

            }
            this.finish.setWaypoints(waypointsFinish);

        }
    }


    async mySetLocation(map: L.map) {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(position => {
                
                this.myLocation = new L.LatLng(position.coords.latitude, position.coords.longitude);
            },
                err => {
                    console.log(err);
                    this._spinner.hide('routing')
                    this._toastService.toastWarning(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"));
                },
                this.options
            );
        }
    }

    private async getLocationList(): Promise<Array<Container>> {
        try {
            this._containers = await this._simulationService.getByPolygonsContainer(this.car.plate);
        } catch (error) {
            console.warn(error);
            this._spinner.hide('routing')
            return [];
        }
    }


    async makeCapitalMarkers(map: L.map): Promise<void> {
        const coordinates: L.LatLng[] = [];
        var finishCoordinates: L.LatLng;
        coordinates.push(L.latLng(this.myLocation)); // 0 kendi konumu
        this._containers.forEach(x => {
            if (x.container.latitude && x.container.longitude) {
                if (x.container.containerType == true) {
                    const marker = L.marker([x.container.latitude, x.container.longitude], { icon: new ContainerIcon({ iconUrl: 'assets/img/end.png' }) });
                    marker.bindPopup(function () {
                        let html = `<div> ${this._translateService.instant("TITLE")} : ${x.container.streetDesc}</div>`;
                        return html;
                    });
                    marker.addTo(map);
                    finishCoordinates = new L.latLng(x.container.latitude, x.container.longitude)
                    return;
                }
                else {
                    var calculate = x.container.device.deviceLatestStatus 
                    ? (((parseInt(x.container.altitude) - parseInt(x.container.deadZone)) - (parseInt(x.container.device.deviceLatestStatus.mesafe) - parseInt(x.container.deadZone)))
                     * 100) / (parseInt(x.container.altitude) - parseInt(x.container.deadZone)) : -1;
                    var map_icon;
                    // cengiz bey isteği çöp konteyneri 4 farklı renge bölme
                    if (calculate <= this.appConfigService.apiConfig["container-msf-yellow"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-green.png' });
                    }
                    else if (calculate <= this.appConfigService.apiConfig["container-msf-orange"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-yellow.png' });
                    }
                    else if (calculate <= this.appConfigService.apiConfig["container-msf-red"]) {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-orange.png' })
                    }
                    else {
                        map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-red.png' })
                    }

                    const marker = L.marker([x.container.latitude, x.container.longitude], { icon: map_icon });

                    var fullnessValue = calculate == -1 ? this._translateService.instant("UNDEFINED_VALUE") : calculate.toString().slice(0, 4);
                    marker.bindPopup(this.makeCapitalPopup(x.container.latitude + "/" + x.container.longitude, x.container.street, x.container.streetDesc, fullnessValue,x.container.name), { closeOnClick: false, autoClose: false })
                    marker.addTo(map);
                    if (calculate > this.polygon.treshold) {
                        coordinates.push(L.latLng(x.container.latitude, x.container.longitude))
                    }
                }
            }
        });
        coordinates.push(finishCoordinates)
        this.destinations = (await this.TSPCalculator(coordinates)).map(s=>s.LatLng);
        this.start = L.Routing.control({//gidiş rotası
            waypoints: this.destinations,    // coordinates in 0. konumu kendi konumumuz aynı zamanda waypointsin 0. sıda 
            lineOptions: {
                styles: [{ color: 'blue', opacity: 0.6, weight: 5 }]
            },
            plan: L.Routing.plan(
                this.destinations,
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            //serviceUrl: 'http://router.project-osrm.org/route/v1',
            serviceUrl: this.appConfigService.apiConfig["routing-url"], //'http://127.0.0.1:5000/route/v1',
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(map);


        let destinationsback = this.destinations.reverse();

        this.finish = L.Routing.control({//dönüş rotası çp merkezine
            waypoints: [destinationsback[0], finishCoordinates],// en son konumdan çöp toplanma merkezine
            plan: L.Routing.plan(
                [destinationsback[0], finishCoordinates],
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            lineOptions: {
                styles: [{ color: 'red', opacity: 0.6, weight: 2 }]
            },
            serviceUrl: this.appConfigService.apiConfig["routing-url"], 
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(map);

    }

    public async TSPCalculator(coords: L.LatLng[]): Promise<Array<OrderCoord>> {
     
        let orderCoords=new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();
     
        let response= await this.getMatris(coords);
        let tsp= await this.postTSP(response.distances);
        let matris = response.distances;

        for (let i = 0; i < matris.length; i++) {
            let orderCoordRR = new OrderCoord();
            orderCoordRR.LatLng = new L.LatLng(response.destinations[i].location[1], response.destinations[i].location[0])
            orderCoordRR.durations = matris[i];
            calculateOrderCoords.push(orderCoordRR);
        }

        for(let a=0;a<tsp.length-1;a++){
            orderCoords.push(calculateOrderCoords[tsp[a]]);
        }
        
        return orderCoords;
    }
    postTSP(durations:any): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.post(this.appConfigService.apiConfig["api-url"]+'routeOptimization/getRouteOptimization',durations)
                .subscribe((response: any) => {
                    resolve(response);
                }, error=>{
                    this._spinner.hide('routing')
                    reject(error)
                });
        });
    }

    getMatris(coords:L.LatLng[]): Promise<any> {
        var httpString: string = "";
        for (let x = 0; x < coords.length; x++) {
            httpString += coords[x].lng + "," + coords[x].lat;
            if (x != coords.length - 1) {
                httpString += ";"
            }
        }
        return new Promise((resolve, reject) => {
            this._http.get(this.appConfigService.apiConfig["table-url"]  + httpString+"?annotations=distance")
                .subscribe((response: any) => {               
                    resolve(response);
                }, error=>{
                    this._spinner.hide('routing')
                    reject(error)
                });
        });
    }
    
    public routingLoop(coords: L.LatLng[]): Array<OrderCoord> {

        let orderCoords = new Array<OrderCoord>();
        let calculateOrderCoords = new Array<OrderCoord>();
        let filterCoords = new Array<OrderCoord>();

        let orderCoord = new OrderCoord(); //ilk konum
        orderCoord.value = 0;
        orderCoord.LatLng = coords[0];
        orderCoords.push(orderCoord);

        let selectedCoord = coords[0];
        coords[0].op = true;

        for (var index_all = 0; index_all < coords.length; index_all++) {  //sadece döngü için 


            calculateOrderCoords = new Array<OrderCoord>();

            filterCoords = coords.filter(x => x !== selectedCoord && x.op !== true);
            for (var index_filter = 0; index_filter < filterCoords.length; index_filter++) {    //sırayla gez hesaplanan noktayı devre dışı bırak
                let coord = filterCoords[index_filter];
                let value = selectedCoord.distanceTo(coord);
                let orderCoord = new OrderCoord();
                orderCoord.value = value;
                orderCoord.LatLng = coord;
                calculateOrderCoords.push(orderCoord);
            }

            let shortestPath = calculateOrderCoords.sort((a, b) => (a.value < b.value ? -1 : 1));

            if (!isNullOrUndefined(shortestPath[0] && shortestPath[0].LatLng)) {

                orderCoords.push(shortestPath[0]); //bulduğun en kısa yolu rota listesine ekle 
                var index = coords.findIndex(function (el) {
                    return el.lat == shortestPath[0].LatLng.lat;
                });
                coords[index].op = true; //en yakını
                selectedCoord = shortestPath[0].LatLng;
            }

        }        
        return orderCoords;

    }



    makeCapitalPopup(latLng: string, street: string, streetDesc, fullness: string,name?:string): string {
        let html = `<div> ${this._translateService.instant("OCCUPANCY")} : % ${fullness}</div>`;
      //  html += `<div> ${this._translateService.instant("LOCATION")}: ${latLng}</div>`;
        html += `<div> ${this._translateService.instant("NAME")}: ${name}</div>`;
        html += `<div> ${this._translateService.instant("TITLE")}: ${streetDesc}</div>`;
        html += `<div> ${this._translateService.instant("STREET")}: ${street}</div>`;
        return html;
    }
}


export class OrderCoord {
    public LatLng?: any
    public value?: number
    public durations?: Array<any>
    public op?: boolean = false
}






